import React from 'react';
import { footerContent } from '../data/mock';

const Footer = () => {
  return (
    <footer className="py-12 px-6 md:px-12 lg:px-24 border-t border-gray-100">
      <div className="max-w-5xl mx-auto text-center">
        <p className="text-gray-500 text-sm">
          © {footerContent.year} {footerContent.companyName}. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
